module.exports = __webpack_public_path__ + "empty-col.png?abb61d86c55971d0d301fee4928f1faa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-col.png
// module id = 30
// module chunks = 0